import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { connectStore } from "redux-box";
import { module as inviteCode } from "@st/inviteCode";
import { module as product } from "@st/product";
import { module as onboard } from "@st/onboard";
import Select from "react-select";
import CheckBox from "./CheckBox";
import {
  DropDownContainer,
  DropDownTitle,
  DatePickerContainer,
} from "./SchoolIroEnable.styled";
import { Th, Td, Tr, Table, Grade } from "./SchoolIroEnable.styled";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  DateSelector,
  DateSelectorIcon,
} from "../../flive-code-view/renewalold-school/RenewalOldSchool.styled";

function SchoolIroEnable(props) {
  const [gradeOption, setGradeOption] = useState([]);
  const [schoolIroEnableData, setSchoolIroEnableData] = useState({
    isEnableSchoolIro: false,
    school: null,
    selectedGrades: [],
    // selectedDate : moment().format("YYYY-MM-DD")
    examDate: "",
    examDatesTable: [],
    test_id: "",
    examStatus: null,
  });

  const [examOptions, setExamOptions] = useState([]);

  useEffect(() => {
    let { schoolEditInfo } = props.inviteCode;
    if (schoolEditInfo) {
      setSchoolIroEnableData({
        ...schoolIroEnableData,
        school: schoolEditInfo.id,
      });
      props.inviteCode.getSchoolIro(schoolEditInfo.id);
    }
    props.inviteCode.getAllGrades();
    props.inviteCode.getIroExamTypes();
  }, []);

  useEffect(() => {
    let gradesList = props.inviteCode.allGrades.map((grade) => {
      return {
        value: grade.id,
        label: grade.name,
      };
    });
    setGradeOption(gradesList);
  }, [props.inviteCode.allGrades]);

  useEffect(() => {
    if (props.inviteCode.iroExamTypes.length > 0) {
      let updatedTypes = props.inviteCode.iroExamTypes
        .filter((exam) => exam.id !== "6a38e898-61c2-4fac-9d36-8587fac6aa5a")
        .map((type) => {
          return {
            label: type.name,
            value: type.id,
          };
        });

      setExamOptions(updatedTypes);
    }
  }, [props.inviteCode.iroExamTypes]);

  useEffect(() => {
    let schoolIro = props.inviteCode.schoolIro;

    if (schoolIro && schoolIro.length > 0) {
      setSchoolIroEnableData({
        ...schoolIroEnableData,
        isEnableSchoolIro: true,
        examDatesTable: schoolIro,
      });
    }
  }, [props.inviteCode.schoolIro]);

  const handleCheckboxChange = (event) => {
    console.log("checked", event.target.checked);
    setSchoolIroEnableData({
      ...schoolIroEnableData,
      isEnableSchoolIro: event.target.checked,
    });
  };

  // const handleExamCompleteCheckboxChange = (event, exam) => {
  //   let examStatus = schoolIroEnableData.examStatus;

  //   if (examStatus) {
  //     setSchoolIroEnableData({
  //       ...schoolIroEnableData,
  //       examStatus: {
  //         ...schoolIroEnableData.examStatus,
  //         [exam.value]: true,
  //       },
  //     });
  //   } else {
  //     setSchoolIroEnableData({
  //       ...schoolIroEnableData,
  //       examStatus: { [exam.value]: true },
  //     });
  //   }

  //   props.inviteCode.setSchoolIroCompletionStatusFormData({
  //     ...schoolIroEnableData,
  //     examStatus: examStatus
  //       ? {
  //           ...schoolIroEnableData.examStatus,
  //           [exam.value]: true,
  //         }
  //       : { [exam.value]: true },
  //   });
  // };

  const handleGradeChange = (event) => {
    // console.log("value selected:",event.target.value);
    // add the grade to schoolIroEnableData.selectedGrades
    setSchoolIroEnableData({
      ...schoolIroEnableData,
      selectedGrades: [...event],
    });

    console.log("selectedGrades:", event);

    // for every object in event get the id of the object and make a list

    updateSchoolIroFormData({
      ...schoolIroEnableData,
      selectedGrades: event,
    });
  };

  const updateSchoolIroFormData = (data) => {
    props.inviteCode.setSchoolIroFormData(data);
  };

  const handleEnableDateChange = (date) => {
    setSchoolIroEnableData({
      ...schoolIroEnableData,
      examDate: moment(date).format("YYYY-MM-DD"),
    });

    updateSchoolIroFormData({
      ...schoolIroEnableData,
      examDate: moment(date).format("YYYY-MM-DD"),
    });
  };
  const onDatepickerRef = (el) => {
    if (el && el.input) {
      el.input.readOnly = true;
    }
  };

  const handleExamTypeChange = (e) => {
    setSchoolIroEnableData({
      ...schoolIroEnableData,
      test_id: e.value,
    });

    updateSchoolIroFormData({
      ...schoolIroEnableData,
      test_id: e.value,
    });
  };

  // useEffect(() => {
  //   if (props.inviteCode.examStatus) {
  //     setSchoolIroEnableData({
  //       ...schoolIroEnableData,
  //       examStatus: props.inviteCode.examStatus,
  //     });
  //   }
  // }, [props.inviteCode.examStatus]);

  return (
    props.inviteCode.schoolEditInfo && (
      <div className="mt-4">
        <div>
          <label>
            <CheckBox
              checked={schoolIroEnableData.isEnableSchoolIro}
              onChange={handleCheckboxChange}
              disabled={
                props.inviteCode.schoolEdit
                  ? !props.inviteCode.schoolEdit
                  : true
              }
            />
            <span style={{ marginLeft: 8 }}>Enable IRO</span>
          </label>
        </div>

        {schoolIroEnableData.isEnableSchoolIro && (
          <Table>
            <thead>
              <Tr className="text-center">
                <Th>Exam Date</Th>
                <Th>Exam Name</Th>
                <Th>Grades</Th>
              </Tr>
            </thead>
            <tbody>
              {schoolIroEnableData.examDatesTable &&
                schoolIroEnableData.examDatesTable.length > 0 &&
                schoolIroEnableData.examDatesTable.map((exam, index) => (
                  <Tr key={index}>
                    <Td className="text-center">{exam.exam_date}</Td>
                    <Td className="text-center">{exam.test_name}</Td>
                    <Td className="text-center">{exam.grade && exam.grade.join(", ")}</Td>
                  </Tr>
                ))}
            </tbody>
          </Table>
        )}
        {schoolIroEnableData.isEnableSchoolIro && (
          <div>
            <DropDownContainer>
              <DropDownTitle>EXAM TYPE</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select exam type"}
                // value={schoolIroEnableData.selectedGrades}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleExamTypeChange}
                options={examOptions.length > 0 && examOptions}
                isMulti={false}
              />
            </DropDownContainer>
            <DropDownContainer>
              <DropDownTitle>SCHOOL GRADES</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select school grades"}
                // value={schoolIroEnableData.selectedGrades}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleGradeChange}
                options={gradeOption}
                isMulti={true}
              />
            </DropDownContainer>
            <DatePickerContainer>
              <h6>Exam Date</h6>
              <DateSelector
                style={{ overflow: "hidden", border: "1px solid #a349c9" }}
              >
                <DateSelectorIcon className="fa fa-calendar" />
                <DatePicker
                  selected={schoolIroEnableData.examDate}
                  selectsStart
                  startDate={schoolIroEnableData.examDate}
                  onChange={handleEnableDateChange}
                  minDate={moment().toDate()}
                  placeholderText="Select Enable Date"
                  disabled={
                    props.inviteCode.schoolEdit
                      ? !props.inviteCode.schoolEdit
                      : true
                  }
                  ref={(el) => onDatepickerRef(el)}
                />
              </DateSelector>
            </DatePickerContainer>

            {/* <div className="mt-4">
              <p>Iro Exam Completion Status</p>
              {examOptions.length > 0 &&
                examOptions.map((exam) => (
                  <div className="mt-4">
                    <label>
                      <CheckBox
                        checked={
                          // props.inviteCode.examStatus &&
                          // props.inviteCode.examStatus[exam.value]
                          //   ? props.inviteCode.examStatus[exam.value]
                          //   :
                          schoolIroEnableData.examStatus &&
                          schoolIroEnableData.examStatus[exam.value]
                            ? schoolIroEnableData.examStatus[exam.value]
                            : false
                        }
                        onChange={(e) =>
                          handleExamCompleteCheckboxChange(e, exam)
                        }
                        disabled={
                          props.inviteCode.schoolEdit
                            ? !props.inviteCode.schoolEdit
                            : true
                        }
                      />
                      <span style={{ marginLeft: 8 }}>{exam.label}</span>
                    </label>
                  </div>
                ))}
            </div> */}
          </div>
        )}
      </div>
    )
  );
}

export default withRouter(
  connectStore({
    inviteCode,
    onboard,
    product,
  })(SchoolIroEnable)
);
